/**
 * BusinessFunctionItemsStore
 * Extends the BaseStore for managing BusinessFunctionItems.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { BusinessFunctionItemInterface } from '@sah/Classes/BusinessFunctionItem';

class BusinessFunctionItemsStore extends BaseStore<BusinessFunctionItemInterface> {}

export default new BusinessFunctionItemsStore();
